import React, { CSSProperties } from 'react';

const SvgIconMemberCare = ({
  color = 'white',
  leafColor = color,
  width = 27,
  height = width * 0.85,
  style,
}: {
  color?: string;
  leafColor?: string;
  width?: number;
  height?: number;
  style?: CSSProperties;
}) => {
  return (
    <div style={style}>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 27 23`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.7459 0.838445C14.0905 1.34135 13.4809 1.93604 12.9472 2.6068C11.8191 3.99389 11.0569 5.6098 10.7062 7.31733C9.57831 5.80813 8.95312 3.9788 8.95312 2.04276V0.762222C8.95312 0.335219 9.28866 0 9.71535 0H10.9959C12.3069 0 13.5874 0.289644 14.7459 0.838445Z"
          fill={color}
        />
        <path
          d="M23.637 0H21.5942C18.6825 0 15.969 1.29578 14.1397 3.55212C12.402 5.71667 11.6853 8.47591 12.1577 11.1743L15.4812 7.85089C15.771 7.546 16.2587 7.546 16.5483 7.85089C16.8532 8.14069 16.8532 8.62836 16.5483 8.918L13.2707 12.1956H14.8104C17.7831 12.1956 20.4815 10.9912 22.2192 8.90276C23.637 7.18014 24.3992 5.06116 24.3992 2.80498V0.762222C24.3992 0.335219 24.064 0 23.637 0Z"
          fill={leafColor}
        />
        <path
          d="M25.4481 12.8815C24.8078 12.3327 23.8474 12.3939 23.2683 13.0037C18.9847 17.469 18.7002 17.795 18.5474 17.897C18.273 18.1561 17.8919 18.2933 17.5262 18.2933H11.789C11.3681 18.2933 11.0268 17.9521 11.0268 17.5311C11.0268 17.1101 11.3681 16.7689 11.789 16.7689H17.023C17.8614 16.7689 18.5474 16.0829 18.5474 15.2444C18.5474 14.406 17.8614 13.72 17.023 13.72H11.9755L11.4008 13.2145C10.2924 12.2387 8.81796 11.7654 7.34544 11.9119C5.99297 12.0472 4.79088 12.6984 3.88987 13.72H0.762064C0.341253 13.72 0 14.0612 0 14.4822V22.106C0 22.526 0.340618 22.8666 0.760793 22.8666H18.9484C19.177 22.8666 19.3936 22.7641 19.5383 22.587L25.6767 15.092C26.2103 14.406 26.1036 13.4303 25.4481 12.8815Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default SvgIconMemberCare;
